export const initialState = {
  fromdb: null,
  tablePages: 0,
  orderDetails: null,
  paymentsDetails: null,
  successModal: {
    show: false,
    message: null,
  },
  errorModal: {
    show: false,
    message: null,
  },
  isLoading: false,
  error: null,
};
